import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnChanges {
  @Input() pagesTotal = 0;
  @Input() numberPage = 1;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
  
  pagesToShow = 5;
  pagesTotals: number[] = [];

  ngOnChanges(changes: SimpleChanges) {
    // Si cambia el total de páginas o la página actual desde el padre, recalculamos
    if (changes['pagesTotal'] || changes['numberPage']) {
      // Validar que la página actual no quede fuera del nuevo rango
      if (this.numberPage > this.pagesTotal && this.pagesTotal > 0) {
        this.numberPage = this.pagesTotal;
      }
      this.recalcularPaginas(this.numberPage);
    }
  }

  recalcularPaginas(currentPage: number) {
    if (this.pagesTotal <= 0) {
      this.pagesTotals = [];
      return;
    }

    // Calcular el rango dinámico centrado en la página actual
    let start = Math.max(1, currentPage - Math.floor(this.pagesToShow / 2));
    let end = start + this.pagesToShow - 1;

    if (end > this.pagesTotal) {
      end = this.pagesTotal;
      start = Math.max(1, end - this.pagesToShow + 1);
    }

    this.pagesTotals = Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  cambiarPagina(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.pagesTotal && pageNumber !== this.numberPage) {
      this.numberPage = pageNumber;
      this.pageChange.emit(this.numberPage);
      this.recalcularPaginas(this.numberPage);
    }
  }

  previus() {
    this.cambiarPagina(this.numberPage - 1);
  }

  next() {
    this.cambiarPagina(this.numberPage + 1);
  }

  first() {
    this.cambiarPagina(1);
  }

  last() {
    this.cambiarPagina(this.pagesTotal);
  }
}